import * as React from "react";

export const ShortcutWalletIcon = (props: any) => (
  <svg
    width={25}
    height={24}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.469 0A1.7 1.7 0 0 0 19 .063L2.75 4.343a2.873 2.873 0 0 0-1.625 1.063A2.945 2.945 0 0 0 .5 7.25V21c0 .813.292 1.52.875 2.125.604.583 1.313.875 2.125.875h18c.813 0 1.51-.292 2.094-.875.604-.604.906-1.313.906-2.125V8c0-.813-.302-1.51-.906-2.094C23.01 5.302 22.312 5 21.5 5H8.125L19.5 2v2h2V2c0-.563-.208-1.031-.625-1.406A1.922 1.922 0 0 0 19.469 0ZM3.5 7h18c.292 0 .531.094.719.281A.974.974 0 0 1 22.5 8v13a.974.974 0 0 1-.281.719.974.974 0 0 1-.719.281h-18a.974.974 0 0 1-.719-.281A.974.974 0 0 1 2.5 21V8c0-.292.094-.531.281-.719A.973.973 0 0 1 3.5 7ZM19 13c-.417 0-.77.146-1.063.438A1.446 1.446 0 0 0 17.5 14.5c0 .417.146.77.438 1.063.291.291.645.437 1.062.437.417 0 .77-.146 1.063-.438.291-.291.437-.645.437-1.062 0-.417-.146-.77-.438-1.063A1.446 1.446 0 0 0 19 13Z"
      fill="#2D5BFF"
    />
  </svg>
);
